
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class IcStockSetAssembleDialog extends Serenity.EntityDialog<IcStockSetAssembleRow, any> {
        protected getFormKey() { return IcStockSetAssembleForm.formKey; }
        protected getIdProperty() { return IcStockSetAssembleRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockSetAssembleRow.localTextPrefix; }
        protected getNameProperty() { return IcStockSetAssembleRow.nameProperty; }
        protected getService() { return IcStockSetAssembleService.baseUrl; }
        protected getDeletePermission() { return IcStockSetAssembleRow.deletePermission; }
        protected getInsertPermission() { return IcStockSetAssembleRow.insertPermission; }
        protected getUpdatePermission() { return IcStockSetAssembleRow.updatePermission; }

        protected form = new IcStockSetAssembleForm(this.idPrefix);

        constructor() {
            super();
            this.form = new IcStockSetAssembleForm(this.idPrefix);
            (this.form.IcStockSetAssembleDtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
            });

            

            this.form.SetItemCode.change(e => {
                var skucode = Q.toId(this.form.SetItemCode.value);
                //#region  การคำนวน โดยส่งfg ไปหลังบ้าน (SQL)
                // this.form.IcStockSetAssembleDtList.value = null
                // if (skucode != null) {
                //     var self = this;

                //     this.form.CallSetItemFg.value = 1;
                //     this.form.CallSetItemFg.forceUpdate();
                //     if (this.validateForm() && this.validateBeforeSave()) {
                //         var options = this.getSaveOptions((response) => {
                //             console.log("doooo0")


                //             if (this.isEditMode()) {

                //                 var id1 = response.EntityId;
                //                 if (id1 == null) {
                //                     id1 = this.get_entityId();
                //                 }
                //                 var a = this.loadById(id1);

                //             }
                //             else {

                //                 var a = this.loadById(response.EntityId);
                //                 console.log("done")
                //             }

                //             //this.showSaveSuccessMessage(response);
                //         });




                //         options.onError = function (response) {
                //             if (response.Error.Message == "Can't save record. There is another record with the same เลขที่เอกสาร value!") {
                //                 Q.alert(response.Error.Message = "เลขที่เอกสารถูกใช้งานแล้ว ระบบจำทำการบรับเลขที่เอกสาร โปรดเลือกสินค้าชุดอีกครั้ง");
                //                 var s = self.form.SysDocNo.value
                //                 var f = s.substring(0, 9)
                //                 GeniuzPOS.Inventory.IcStockSoldService.GetNextNumber({
                //                     Prefix: f,
                //                     Length: 15
                //                 }, response => {

                //                     self.form.SysDocNo.value = response.Serial;
                //                     self.form.SetItemCode.value = null

                //                 });
                //                 // this.save((response2) => {
                //                 //     if (this.isEditMode()) {
                //                 //         var id1 = response2.EntityId;
                //                 //         if (id1 == null) {
                //                 //             id1 = this.get_entityId();
                //                 //         }
                //                 //         this.loadById(id1);
                //                 //     }
                //                 //     else {
                //                 //         var a = this.loadById(response.EntityId);
                //                 //     }

                //                 //     ///this.showSaveSuccessMessage(response2);
                //                 // });


                //             } //else { Q.alert(response.Error.Message); }


                //         }
                //         Q.serviceCall(options);

                //     }

                // }
               // #endregion
               
                var orderNo = this.form.SetItemCode.value;
                if(!Q.isEmptyOrNull(orderNo)){
                    this.form.IcStockSetAssembleDtList.SetItemCode = this.form.SetItemCode.value;
                        // const getPO = Q.first(this.form.SetItemCode.items, x=> (x.source as Product.PsSetItemRow).SetItemCode == orderNo);
                        // this.setPurOrderDetails(getPO.source);
                    this.form.IcStockSetAssembleDtList.refresh();
                }else{
                    this.form.IcStockSetAssembleDtList.clearDataGrid();
                }
                this.form.SetQty.value =1
            
            });

            this.form.SetQty.changeSelect2(e => {
                var orderNo = this.form.SetQty.value;
                console.log("order: " + orderNo);
                if(orderNo > 0){
                    this.form.IcStockSetAssembleDtList.QtySetItem = this.form.SetQty.value;
                        // const getPO = Q.first(this.form.SetItemCode.items, x=> (x.source as Product.PsSetItemRow).SetItemCode == orderNo);
                        // this.setPurOrderDetails(getPO.source);
                    this.form.IcStockSetAssembleDtList.refresh();
                }else{
                    this.form.IcStockSetAssembleDtList.clearDataGrid();
                }
            
            });


        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
               

                // let CallSetItemFg: Serenity.ToolButton =  
                // {
                //     title: "",
                //     hint: "คำนวน Qty",
                //     separator: false,
                //     cssClass: "cal-qtysetItem",
                //     icon: "fa fa-redo-alt",//redo-alt  //search
                //     //hotkey: 'alt+shift+s',
                //     onClick: (e) => {
                //         var skucode = Q.toId(this.form.SetItemCode.value);

                //         this.form.IcStockSetAssembleDtList.value = null
                //         if (skucode != null) {
                //             var self = this;

                //             this.form.CallSetItemFg.value = 1;
                //             this.form.CallSetItemFg.forceUpdate();
                //             if (this.validateForm() && this.validateBeforeSave()) {
                //                 var options = this.getSaveOptions((response) => {
                //                     console.log("doooo0")


                //                     if (this.isEditMode()) {

                //                         var id1 = response.EntityId;
                //                         if (id1 == null) {
                //                             id1 = this.get_entityId();
                //                         }
                //                         var a = this.loadById(id1);

                //                     }
                //                     else {

                //                         var a = this.loadById(response.EntityId);
                //                         console.log("done")
                //                     }

                //                     //this.showSaveSuccessMessage(response);
                //                 });

                //                 Q.serviceCall(options);
                //             }
                //         }




                //     }
                // }; buttons.push(CallSetItemFg);


                let newSaveBtn: Serenity.ToolButton =
                {
                    title: "บันทึกเอกสาร",
                    hint: "Save",
                    separator: false,
                    cssClass: "button-save",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        var self = this;
                        this.form.WhsItem.element.toggleClass("required", true);
                        this.form.WhsSet.element.toggleClass("required", true);
                        this.form.SetItemCode.element.toggleClass("required", true);

                        //ถ้าแก้เรื่องการใช้งานบนหน้าแล้วข้อมูลDt ขาอัพเดตไม่นำตัวใหม่ไปใช้งานได้แล้วมาปิด2บรรทัดนี้
                        // this.form.IcStockSetAssembleDtList.value = null
                        // this.form.CallSetItemFg.value = 1;
                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    //this.loadById(id1);
                                    this.dialogClose();
                                }
                                else {
                                    // this.loadById(response.EntityId);
                                    this.dialogClose();
                                }

                                this.showSaveSuccessMessage(response);


                            });

                            options.onError = function (response) {
                                if (response.Error.Message == "Can't save record. There is another record with the same เลขที่เอกสาร value!") {
                                    //Q.alert(response.Error.Message = "เลขที่เอกสารถูกใช้งานแล้ว ระบบจำทำการบรับเลขที่เอกสาร โปรดทำการบันทึกอีกครั้ง");
                                    var s = self.form.SysDocNo.value
                                    var f = s.substring(0, 9)
                                    GeniuzPOS.Inventory.IcStockSetAssembleService.GetNextNumber({
                                        Prefix: f,
                                        Length: 15
                                    }, response => {

                                        self.form.SysDocNo.value = response.Serial;

                                    });                                    


                                } else { Q.alert(response.Error.Message); }



                            }

                            Q.serviceCall(options);
                        } else {
                            this.save((response) => {
                                this.dialogClose();
                            });


                        }

                    }
                };
                buttons.push(newSaveBtn);

                let newDeleteBtn: Serenity.ToolButton =
                {
                    title: "ลบเอกสาร'",
                    hint: "Delete",
                    separator: false,
                    cssClass: "delete-button",
                    icon: "fa fa-save",
                    hotkey: 'alt+x',
                    onClick: (e) => {
                        Q.confirm('ยืนยันการลบเอกสาร', () => {
                            this.form.CancelFg.value = "2";
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                    }
                };
                buttons.push(newDeleteBtn);


            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            //this.form.IcStockSetAssembleDtList.myPassValue = this.entity.SysDocNo

            if (this.isNew()) {
                this.getNextNumber();
                //this.toolbar.findButton('button-save-post').hide();
                this.toolbar.findButton('delete-button').hide();


            }


            //$('<a class="inplace-button inplace-create"><b><\/b><\/a>').insertAfter(this.form.SetItemCode.element).click(() => this.myFunction()); //ต้นฉบับ

            // this.toolbar.findButton('cal-qtysetItem').insertAfter(this.form.SetQty.element)  // <======================


            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            // self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        // if (self.element.parent().find(".panel-titlebar").length == 1) {
                        //     // self.element.parent().find(".panel-titlebar").html("");
                        //     // self.element.parent().find(".panel-titlebar-text").html("");
                        //     self.element.parent().find(".panel-titlebar-close").html("");
                        // }
                        // else {
                        //     changeTitle();
                        // }
                    }
                }, 100);
            })();
            if (this.entity.PostFg == 1 || this.entity.PostFg == 2 || this.entity.CancelFg == 1) {
                this.toolbar.findButton('cal-qtysetItem').hide();
                //this.toolbar.findButton('genarate-po-button').hide();
                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('button-save').hide();
                this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);
                //Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                // this.applyChangesButton.toggleClass('disabled', true);
                // this.saveAndCloseButton.toggleClass('disabled', true);
                this.deleteButton.toggleClass('disabled', true);
                this.form.IcStockSetAssembleDtList.set_readOnly(true);
            } else {
                this.toolbar.findButton('apply-changes-button').hide();

            }
        }


        // protected getSaveEntity(): IcStockSetAssembleRow {
        //     let entity = super.getSaveEntity();

        //     return entity;
        // }

        private getNextNumber() {
            var val = Q.trimToNull(this.form.SysDocNo.value);



            if (!val || val.length <= 3) {
                var someDate = new Date();
                var dd = someDate.getDate();
                var mm = someDate.getMonth() + 1;
                var myRow = 0;
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                console.log('User Id : ' + userId.ShopId);
                try {
                    var userRole = Q.first(Administration.UserRoleRow.getLookup().items, x => x.UserId == userId.UserId);

                    if (userRole != null) {
                        myRow = userRole.RoleId;
                    }
                    if (userRole != null || userRole.RoleId.valueOf) {
                        myRow = userRole.RoleId;
                    }
                    if (myRow == 1) {
                        //(this.form.SlmnCode.element as any).select2(userId.SlmnCode);
                    }
                } catch {

                }

                var y = someDate.getFullYear();
                var mo = "";
                var ddd = "";

                if (mm < 10) {
                    mo = '0' + mm;

                } else {
                    mo = mm.toString();
                }

                if (dd < 10) {
                    //ddd = '0' + dd;
                    ddd = '';

                } else {
                    //ddd = dd.toString();
                    ddd = '';
                }

                var someFormattedDate = y.toString().substr(2, 2);

                var docprefix = Q.tryFirst(Product.CsDocTypeRow.getLookup().items, x => x.DocType == "39").DocPrefix;
                var prefix = docprefix + userId.ShopId + someFormattedDate + mo + ddd;
                GeniuzPOS.Inventory.IcStockSetAssembleService.GetNextNumber({
                    Prefix: prefix,
                    Length: 15
                }, response => {

                    this.form.SysDocNo.value = response.Serial;
                    this.form.DocDate.element.focus();
                    // return true;
                });
                // return false;
            }

        }

        // public setPurOrderDetails(details: PurOrderRow){
        //     this.form.ForeignType.value = String(details.ForeignType);
        //     this.form.SupplId.value = String(details.SupplId);
        //     this.form.CrtId.value = String(details.CrtId);
        //     this.form.CurcyId.value = String(details.CurcyId);
        //     this.form.ExchangeRate.value = details.ExchangeRate;
        //     this.form.DueDate.value = details.DueDate;
        //     this.form.ETADate.value = details.ETADate;
        //     this.form.ETDDate.value = details.ETDDate;
        //     this.form.IncoId.value = String(details.IncoId);
        //     this.form.VatRate.value = String(details.VatRate);
        //     this.form.ShipDate.value = details.ShipDate;
        //     this.form.BranchId.value = details.BranchId.toString();
        //     this.form.WhsId.value = details.WhsId.toString();
        //     this.form.ProjId.value = String(details.ProjId);
        //     this.form.DeptId.value = String(details.DeptId);
        //     this.form.Remark.value = details.Remark;
        //     this.form.DiscString.value = parseFloat(details.DiscString);
        //     this.form.ShipAddress.value = details.ShipAddress;
        //     this.form.ShipVia.value = details.ShipVia;
        // }

    }
}